import { ThemeDefinition } from 'vuetify';

// Used for subjects Swedish and Finnish
export const marketLanguage: ThemeDefinition = {
  dark: false,
  colors: {
    'subject-original': '#EF7B47',
    'on-subject-original': '#FFFFFF',
    subject: '#CA4B12',
    'on-subject': '#FFFFFF',
    primary: '#9B390D',
    'on-primary': '#FFFFFF',
    'primary-container': '#F9CDB9',
    'on-primary-container': '#381505',
    secondary: '#6B5247',
    'on-secondary': '#FFFFFF',
    'secondary-container': '#E0D6D1',
    'on-secondary-container': '#251C18',
    surface: '#FCF9F7',
    'on-surface': '#201E1D',
    'on-surface-medium': '#504B49',
    'on-surface-low': '#9E9794',
    outline: '#867D79',
    'outline-variant': '#CFCBC9',
    'inverse-surface': '#422D24',
    'inverse-on-surface': '#F6F1EE',
    'inverse-primary': '#F7BCA1',
    'surface-dim': '#EBCEC2',
    'surface-bright': '#FEFCFB',
    'surface-container-lowest': '#FFFFFF',
    'surface-container-low': '#FAF3F0',
    'surface-container': '#F7EDE8',
    'surface-container-high': '#F2E1D9',
    'surface-container-highest': '#F0DBD1',
  },
};

export const marketLanguageDark: ThemeDefinition = {
  dark: true,
  colors: {
    'subject-original': '#EF7B47',
    'on-subject-original': '#FEF8F6',
    subject: '#F4A27C',
    'on-subject': '#381505',
    primary: '#F9CDB9',
    'on-primary': '#381505',
    'primary-container': '#8D350C',
    'on-primary-container': '#FDEEE8',
    secondary: '#D6CCC7',
    'on-secondary': '#231D1A',
    'secondary-container': '#584841',
    'on-secondary-container': '#F4F2F0',
    surface: '#181310',
    'on-surface': '#F3F2F2',
    'on-surface-medium': '#CFCBC9',
    'on-surface-low': '#867D79',
    outline: '#9E9794',
    'outline-variant': '#6B6461',
    'inverse-surface': '#EDE3DE',
    'inverse-on-surface': '#281B15',
    'inverse-primary': '#5E2308',
    'surface-dim': '#15110E',
    'surface-bright': '#46362F',
    'surface-container-lowest': '#120E0C',
    'surface-container-low': '#1F1814',
    'surface-container': '#281F1B',
    'surface-container-high': '#342823',
    'surface-container-highest': '#43342D',
  },
};
